export default __webpack_public_path__ + "static/media/down-2.a22f1615.svg";